exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header[data-v-44ec16f7]{background:#a9a9a9;color:#fff}", ""]);

// exports
